export const AB_TESTS_DATA = [
  { id: 'ab1', name: 'Push Copy v2',      hyp: 'Emoji urgency drives higher CTR',     va: 'Short headline',   vb: 'Emoji + urgency',  winner: 'B', lift: '+18.4%', conf: '97%', st: 'completed' },
  { id: 'ab2', name: 'Onboarding Step 2', hyp: 'Value prop before permission screen', va: 'Permission first', vb: 'Value prop first', winner: 'B', lift: '+11.2%', conf: '96%', st: 'completed' },
  { id: 'ab3', name: 'Cart Push Timing',  hyp: '1h delay outperforms 15 min',         va: '15 min delay',     vb: '1 hour delay',     winner: '—', lift: '—',      conf: '74%', st: 'running'   },
];

export const AB_CHART_DATA = {
  labels: ['Push Copy — A','Push Copy — B','Onboard Step — A','Onboard Step — B','Cart Timing — A','Cart Timing — B'],
  data:   [3.2, 3.78, 6.1, 6.9, 4.8, 5.1],
  colors: [
    'rgba(185,64,64,.45)', 'rgba(90,158,120,.6)',
    'rgba(185,64,64,.45)', 'rgba(90,158,120,.6)',
    'rgba(185,64,64,.45)', 'rgba(168,136,58,.6)',
  ],
};

export const AB_CONFIDENCE_DATA = {
  labels: ['Push Copy v2','Onboarding Step 2','Cart Timing'],
  data:   [97, 96, 74],
  colors: ['rgba(90,158,120,.6)','rgba(90,158,120,.6)','rgba(168,136,58,.55)'],
};

export const AB_TEST_EMPTY = {
  id: null, name: '', hyp: '', va: '', vb: '', winner: '—', lift: '—', conf: '0%', st: 'running',
};
